var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5H6",
    stroke: "white",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5H14",
    stroke: "white",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5V14.5",
    stroke: "white",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.5V14.5",
    stroke: "white",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5H4C2.89543 2.5 2 3.39543 2 4.5V12.5C2 13.6046 2.89543 14.5 4 14.5H12C13.1046 14.5 14 13.6046 14 12.5V4.5C14 3.39543 13.1046 2.5 12 2.5Z",
    stroke: "white",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerIcon);
export default __webpack_public_path__ + "static/media/ledger_icon.d5e1916def0ff9b3871f81497ed879f1.svg";
export { ForwardRef as ReactComponent };